import { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { AdCreativeInit } from 'common/api/v1/types'

type Props = {
  open: boolean
  onClose: () => void
  onCreate: (init: AdCreativeInit) => void
}

const CreateDialog = ({ open, onClose, onCreate }: Props) => {
  const [name, setName] = useState('')

  const handleNext = () => {
    if (name.trim()) {
      onCreate({ name: name.trim() })
    }
  }

  useEffect(() => {
    if (open) {
      setName('')
    }
  }, [open])

  return (
    <Dialog data-test-id={'ad-creative-create-dialog'} open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h2" component="div" sx={{ fontWeight: 'normal' }}>
          Create new ad creative
        </Typography>
      </DialogTitle>

      <DialogContent>
        <TextField
          name="name"
          fullWidth
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
          margin="normal"
        />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          You will upload your file in the next step.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button id={'button-cancel'} onClick={onClose}>
          Cancel
        </Button>
        <Button id={'button-next'} onClick={handleNext} variant="contained" disabled={!name.trim()}>
          Next
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CreateDialog
